import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["activity", "translate"]

  connect() {
    this.originalContent = this.activityTarget.value
  }

  handleTextChange() {
    if (this.hasTranslateTarget && this.activityTarget.value !== this.originalContent) {
      this.enableTranslateButton()
    }
  }

  handleDisabilitiesChange(event) {
    const textArea = event.target
    const container = textArea.closest(".relative")
    const translateButton = container.querySelector('[data-translation-target="translate"]')

    if (translateButton) {
      translateButton.disabled = false
      translateButton.classList.remove("opacity-50", "cursor-not-allowed")
      translateButton.classList.add("hover:bg-green-600", "cursor-pointer")
    }
  }

  enableTranslateButton() {
    if (this.hasTranslateTarget) {
      this.translateTarget.disabled = false
      this.translateTarget.classList.remove("opacity-50", "cursor-not-allowed")
      this.translateTarget.classList.add("hover:bg-green-600", "cursor-pointer")
    }
  }

  translateText(event) {
    event.preventDefault()

    const button = event.currentTarget
    const container = button.closest(".relative")
    const textArea = container.querySelector("textarea")

    if (!textArea) return

    const token = document.head.querySelector('meta[name="csrf-token"]').getAttribute("content")
    const originalText = textArea.value

    textArea.disabled = true
    button.disabled = true
    button.classList.add("opacity-50", "cursor-not-allowed")
    button.classList.remove("hover:bg-green-600", "cursor-pointer")
    textArea.value = "Loading..."

    fetch("/translate", {
      method: "POST",
      body: JSON.stringify({
        text: originalText,
        target_language: "de",
      }),
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Translation failed")
        }
        return res.json()
      })
      .then((data) => {
        const translatedText = data.translated_text || originalText
        textArea.value = translatedText

        if (textArea === this.activityTarget) {
          this.originalContent = translatedText
        }
      })
      .catch((err) => {
        console.error("Translation error:", err)
        textArea.value = originalText
        button.disabled = false
        button.classList.remove("opacity-50", "cursor-not-allowed")
        button.classList.add("hover:bg-green-600", "cursor-pointer")
      })
      .finally(() => {
        textArea.disabled = false
      })
  }
}
